import * as React from 'react'
import { Row } from 'antd'
import { isMobile } from 'react-device-detect'
import { injectIntl, IntlShape } from 'react-intl'
import moment from 'moment'
import Timeline, { TimelineOrientation } from '../Timeline/Timeline'
import { DeliveryStatus, ValidDeliveryStatuses } from '../../store/DeliveryTracking/types'
import { isRtl } from '../../config/locales'
import { FadingView } from '../FadingView/FadingView'

const PROGRESS_UPDATE_INTERVAL: number = 1000

interface DeliveryTimelineProps {
  status: DeliveryStatus
  show: boolean
  color: string
  inRouteFrom: moment.Moment
  willArriveAt: moment.Moment
  intl: IntlShape
}

interface DeliveryTimelineState {
  progressToNextStep: number
  progressUpdateInterval: any
}

class DeliveryTimeline extends React.Component<DeliveryTimelineProps, DeliveryTimelineState> {
  constructor(props: any) {
    super(props)
    this.state = {
      progressToNextStep: 0,
      progressUpdateInterval: null,
    }

    this.updateProgess = this.updateProgess.bind(this)
    this.startMonitoringProgress = this.startMonitoringProgress.bind(this)
    this.stopMonitoringProgress = this.stopMonitoringProgress.bind(this)
  }

  updateProgess = () => {
    const { status, inRouteFrom, willArriveAt } = this.props
    let progressToNextStep = 0
    const now = moment()
    if (status === DeliveryStatus.Arriving
      && inRouteFrom.isValid()
      && willArriveAt.isValid()
      && willArriveAt.isAfter(inRouteFrom)
      && inRouteFrom.isBefore(now)) {
      const totalDuration = inRouteFrom.diff(willArriveAt)
      const progress = inRouteFrom.diff(now)
      progressToNextStep = (progress / totalDuration) * 100
    }

    this.setState({ progressToNextStep })
  }

  startMonitoringProgress = () => {
    this.stopMonitoringProgress()
    this.updateProgess()
    const newInterval = setInterval(() => {
      this.updateProgess()
    }, PROGRESS_UPDATE_INTERVAL)
    this.setState({ progressUpdateInterval: newInterval })
  }

  stopMonitoringProgress = () => {
    const { progressUpdateInterval } = this.state
    if (progressUpdateInterval) {
      clearInterval(progressUpdateInterval)
      this.setState({ progressUpdateInterval: undefined })
    }
  }

  componentWillMount(): void {
    this.startMonitoringProgress()
  }

  componentWillUnmount(): void {
    this.stopMonitoringProgress()
  }


  render() {
    const { intl: { formatMessage }, status, show, color } = this.props
    const { progressToNextStep } = this.state
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)

    const steps: string[] = [
      translate('in_preparation'),
      translate('on_its_way'),
      translate('arriving_soon'),
      translate('delivered'),
    ]
    const orientation = isMobile ? TimelineOrientation.Vertical : TimelineOrientation.Horizontal

    return (
      <FadingView pose={show ? 'visible' : 'hidden'}>
        <Row>
          {ValidDeliveryStatuses.includes(status)
            && (
            <Timeline
              barColor="#efefef"
              progressColor={color}
              steps={steps}
              currentStep={ValidDeliveryStatuses.indexOf(status)}
              rtl={isRtl()}
              orientation={orientation}
              verticalBarHeight={160}
              animateCurrentStep={() => status !== DeliveryStatus.Completed}
              progressToNextStep={progressToNextStep}
            />
            )}
        </Row>
      </FadingView>
    )
  }
}

export default injectIntl(DeliveryTimeline)
